import React from "react";
import MobileToggleSvg from "../../svgComponents/MobileToggleSvg";

const ToggleButtonMobile = ({ toggleTheme }) => {
  return (
    <button
      onClick={toggleTheme}
      type="button"
      className="py-3 px-4 flex items-center gap-2 w-full rounded-lg bg-white dark:bg-navyAccent"
    >
      <MobileToggleSvg />
      <p className="text-sm text-black leading-[21px] dark:text-white">
        Black theme
      </p>
    </button>
  );
};

export default ToggleButtonMobile;
